// Global Shoplift Test JS


//////////////////////////////////////////////

/*==============================================================================
TEST ID: [CHS-130] [SEARCH] Auto Load More Button [ALL]
PLATFORM: Shoplift
DATE: 2026-07

GOAL:
When scrolling down a PLP/Collections/Search Page at the end of the results, once the Load More button enters the screen view this code will update the buttons copy to "Loading More" automatically click the CTA to load the following set of results.

KEY INSIGHT:
Target is specific by URL

BEHAVIOR:
- will update the CTA "Load More" copy to "Loading More"
- Only triggers Load More CTAs when they are on viewable on screen 
- Observes class attribute as lightweight fallback (future-safe)
==============================================================================*/

// Initialize test
async function initTestCHS_130() {
    
    // Configuration
    const TEST_ID = 'CHS130';
    const HYPOTHESIS_ID = '019ead4c-0ed5-7638-95a8-5c0a21c89daf';
    let variantResult = null;

    // Targeting - SEARCH only
    if (!window.location.pathname.startsWith('/search')) {
        return;
    }

    try {
        // Check if visitor is in the variant group
        variantResult = await window.shoplift.isHypothesisActive(HYPOTHESIS_ID);

        if (variantResult) {

            // Scroll trigger (behavioral gating)
            function waitForScrollNearLoadMore(callback) {

                var triggered = false;

                function checkScroll() {

                    if (triggered) {
                        return;
                    }

                    var button = document.querySelector('.button.button--black-outline');

                    if (!button) {
                        return;
                    }

                    var rect = button.getBoundingClientRect();

                    // Trigger just before button enters view
                    if (rect.top < window.innerHeight + 150) {

                        triggered = true;
                        window.removeEventListener('scroll', checkScroll);

                        console.log(TEST_ID + ' → Scroll trigger met');

                        callback();
                    }
                }

                window.addEventListener('scroll', checkScroll);
            }

            // Delay execution until scroll condition met
            waitForScrollNearLoadMore(function() {

                // TEST - Show Variant          
                (function() {

                    // One-run guard
                    if (window[TEST_ID + '_INIT']) {
                        return;
                    }
                    window[TEST_ID + '_INIT'] = true;

                    var buttonSelector = '.button.button--black-outline';

                    // Check if element is in viewport
                    function isInViewport(el) {
                        if (!el) {
                            return false;
                        }

                        var rect = el.getBoundingClientRect();

                        if (rect.top < window.innerHeight && rect.bottom > 0) {
                            return true;
                        }

                        return false;
                    }

                    // Attempt click + update button copy
                    function tryClick(button) {
                        if (!button) {
                            return false;
                        }

                        if (button.disabled) {
                            return false;
                        }

                        if (isInViewport(button)) {

                            var label = button.querySelector('span');
                            if (label) {
                                label.textContent = 'Loading more';
                            } else {
                                button.textContent = 'Loading more';
                            }

                            button.click();
                            console.log(TEST_ID + ' → Clicked Load More:', button);

                            return true;
                        }

                        return false;
                    }

                    // Fast retry burst
                    function clickWithRetry() {
                        var attempts = 0;
                        var maxAttempts = 5;

                        var retryInterval = setInterval(function() {

                            var button = document.querySelector(buttonSelector);
                            var success = tryClick(button);

                            if (success) {
                                clearInterval(retryInterval);
                            }

                            attempts = attempts + 1;

                            if (attempts >= maxAttempts) {
                                clearInterval(retryInterval);
                            }

                        }, 120);
                    }

                    // Initial run
                    function init() {
                        clickWithRetry();
                    }

                    init();

                    // Watch for new products loading
                    var mutationObserver = new MutationObserver(function(mutations) {

                        var shouldCheck = false;

                        mutations.forEach(function(mutation) {
                            if (mutation.addedNodes && mutation.addedNodes.length > 0) {
                                shouldCheck = true;
                            }
                        });

                        if (shouldCheck) {
                            setTimeout(function() {
                                clickWithRetry();
                            }, 100);
                        }

                    });

                    mutationObserver.observe(document.body, {
                        childList: true,
                        subtree: true
                    });

                    // Fallback guard
                    setInterval(function() {
                        clickWithRetry();
                    }, 800);

                })();

                console.log('Showing ' + TEST_ID + ' Variant (On Scroll Trigger)');

            });

        } else {
            // Show control
            // NO CHANGES DO NOTHING
            console.log(`Showing ${TEST_ID} Control`);
        }

    } catch (error) {
        // Always fail gracefully - show control experience on error
        console.error(`Shoplift test ${TEST_ID} failed:`, error);
    }
}

// Guard Check - Safely Checking for Shoplift
function whenShopliftReady(cb, timeoutMs) {

    if (!timeoutMs) {
        timeoutMs = 5000;
    }

    var start = Date.now();

    var tick = setInterval(function () {
        if (window.shoplift) {
            clearInterval(tick);
            cb();
        } else if (Date.now() - start > timeoutMs) {
            clearInterval(tick);
            console.warn('Shoplift not available after ' + timeoutMs + 'ms');
        }
    }, 50);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
        whenShopliftReady(initTestCHS_130);
    });
} else {
    whenShopliftReady(initTestCHS_130);
}

////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////

/*==============================================================================
TEST ID: CHS-131B [Cart] Horizontal Checkout CTAs [ALL]
PLATFORM: Shoplift
DATE: 2026-06

GOAL:
Remove `.additional-checkout-buttons--vertical` so Shopify applies native
horizontal layout for Shop Pay / PayPal buttons.

KEY INSIGHT:
Layout is controlled by wrapper class, NOT shadow DOM.
No CSS overrides required.

BEHAVIOR:
- Runs once on load (primary path)
- Observes class attribute as lightweight fallback (future-safe)
==============================================================================*/

// Initialize test
async function initTestCHS_131B() {
    
    // Configuration
    const TEST_ID = 'CHS131B';
    const HYPOTHESIS_ID = '019eff9c-a24c-796f-abef-9a3fec884ff1';
    let variantResult = null;

    try {
        // Check if visitor is in the variant group
        variantResult = await window.shoplift.isHypothesisActive(HYPOTHESIS_ID);

        if (variantResult) {
            
            // TEST - Show Variant
            (function () {

                //==========================
                // ONE-RUN GUARD
                //==========================
                if (window[TEST_ID + '_INIT']) {
                    return;
                }
                window[TEST_ID + '_INIT'] = true;

                //==========================
                // CORE FUNCTION
                //==========================
                function removeVerticalClass() {
                    var el = document.querySelector('.additional-checkout-buttons');

                    if (!el) return;

                    if (el.classList.contains('additional-checkout-buttons--vertical')) {
                        el.classList.remove('additional-checkout-buttons--vertical');
                        console.log(TEST_ID + ' Removed vertical class');
                    }
                }
								
								//==========================
                // EARLY FORCE RUN (NEW FIX)
                //==========================
                removeVerticalClass();

                //==========================
                // WAIT FOR ELEMENT
                //==========================
                function waitForElement(selector, callback) {
                    var attempts = 0;
                    var maxAttempts = 20;

                    var interval = setInterval(function () {
                        var el = document.querySelector(selector);

                        if (el) {
                            clearInterval(interval);
                            callback(el);
                        }

                        attempts = attempts + 1;

                        if (attempts >= maxAttempts) {
                            clearInterval(interval);
                        }

                    }, 150);
                }

                //==========================
                // INIT FUNCTION
                //==========================
                function init() {
                    var el = document.querySelector('.additional-checkout-buttons');

                    if (!el) return;

                    removeVerticalClass();

                    //==========================
                    // LIGHTWEIGHT FALLBACK
                    //==========================                    
										var observer = new MutationObserver(function () {
											setTimeout(function () {
												removeVerticalClass();
											}, 50);
										});


                    observer.observe(el, {
                        attributes: true,
                        attributeFilter: ['class']
                    });
                }

                //==========================
                // START (with waitForElement)
                //==========================
                function start() {
                    waitForElement('.additional-checkout-buttons', function () {
                        init();
                    });
                }

                //==========================
                // LOAD HANDLING
                //==========================
                if (document.readyState === 'complete' || document.readyState === 'interactive') {
                    start();
                } else {
                    document.addEventListener('DOMContentLoaded', start);
                }

            })();

            console.log(`Showing ${TEST_ID} Variant`);

        } else {
            console.log(`Showing ${TEST_ID} Control`);
        }

    } catch (error) {
        console.error(`Shoplift test ${TEST_ID} failed:`, error);
    }
}

// Guard Check - Safely Checking for Shoplift
function whenShopliftReady(cb, timeoutMs = 5000) {
    var start = Date.now();

    var tick = setInterval(function () {
        if (window.shoplift) {
            clearInterval(tick);
            cb();
        } else if (Date.now() - start > timeoutMs) {
            clearInterval(tick);
            console.warn('Shoplift not available after ' + timeoutMs + 'ms');
        }
    }, 50);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
        whenShopliftReady(initTestCHS_131B);
    });
} else {
    whenShopliftReady(initTestCHS_131B);
}

////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////

/*==============================================================================
TEST ID: [CHS-106D] [CART] Display Savings 20% and up [ALL]
PLATFORM: Shoplift
DATE: 2026-06

GOAL:
Calculates between listing and sales price savings if 20% or more.

BEHAVIOR:

- Inserts a CSS/span class for calculated savings %
- Updates on Cart refresh
- Excludes Socks or items with div class .list-unstyled
==============================================================================*/

// Initialize test
async function initTestCHS_106D() {

    // Configuration
    const TEST_ID = 'CHS106D';
    const HYPOTHESIS_ID = '019eb2bb-026a-7191-b0ef-a9203ef17ced';
    let variantResult = null;

    try {
        variantResult = await window.shoplift.isHypothesisActive(HYPOTHESIS_ID);

        if (variantResult) {

            (function () {

                //==========================
                // ONE-RUN GUARD
                //==========================
                if (window[TEST_ID + '_INIT']) return;
                window[TEST_ID + '_INIT'] = true;


                //==========================
                // CSS INJECTION
                //==========================
                function injectStyles() {
                    var styleId = TEST_ID + '-CSS';
                    if (document.getElementById(styleId)) return;

                    var css = ''
                        + '.' + TEST_ID + '-savePercSlot {'
                        + '  color: #3ba029;'
                        + '  font-weight: bold;'
                        + '  white-space: nowrap;'
                        + '  display: none;'
                        + '}';

                    var styleEl = document.createElement('style');
                    styleEl.id = styleId;
                    styleEl.appendChild(document.createTextNode(css));
                    document.head.appendChild(styleEl);
                }


                //==========================
                // CALCULATE SAVINGS
                //==========================
                function calcSav(listPrice, salesPrice) {
                    var lp = parseFloat(listPrice);
                    var sp = parseFloat(salesPrice);

                    if (isNaN(lp)) return '';
                    if (isNaN(sp)) return '';
                    if (lp <= 0) return '';
                    if (sp < 0) return '';
                    if (sp >= lp) return '';

                    return Math.floor(((lp - sp) / lp) * 100);
                }


                //==========================
                // FIND SALE PRICE - First visible span
                //==========================
                function getSalePriceEl(container) {
                    var spans = container.querySelectorAll('span');

                    for (var i = 0; i < spans.length; i++) {
                        var span = spans[i];
                        if (!span) continue;

                        var cls = '';
                        if (typeof span.className === 'string') {
                            cls = span.className;
                        }

                        if (cls.indexOf(TEST_ID + '-savePercSlot') !== -1) continue;
                        if (cls.indexOf('visually-hidden') !== -1) continue;

                        return span;
                    }

                    return null;
                }

                //==========================
                // UPDATE SINGLE TILE
                //==========================
                function updateSavings(tile) {
                    if (!tile) return;

                    var container = tile.querySelector('.cart-items__details-price');
                    if (!container) return;

                    var slot = container.querySelector('.' + TEST_ID + '-savePercSlot');
                    if (!slot) {
                        container.insertAdjacentHTML(
                            'beforeend',
                            '<span class="' + TEST_ID + '-savePercSlot body-xs"></span>'
                        );
                        slot = container.querySelector('.' + TEST_ID + '-savePercSlot');
                    }

                    if (!slot) return;

                    var listEl = container.querySelector('s');
                    var saleEl = getSalePriceEl(container);

                    if (!listEl || !saleEl) {
                        slot.innerHTML = '';
                        slot.style.display = 'none';
                        return;
                    }

                    var listPrice = listEl.innerText.replace(/([^0-9\.])/g, '');
                    var salesPrice = saleEl.innerText.replace(/([^0-9\.])/g, '');

                    var discountPct = calcSav(listPrice, salesPrice);

                    if (discountPct !== '' && discountPct >= 20) {
                        slot.innerHTML = 'You Save ' + discountPct + '%';
                        slot.style.display = 'inline'; // ✅ FIXED
                    } else {
                        slot.innerHTML = '';
                        slot.style.display = 'none';
                    }
                }


                //==========================
                // UPDATE ALL TILES
                //==========================
                function updateSavingsAll() {
                    var tiles = document.querySelectorAll('.cart-items__details');

                    for (var i = 0; i < tiles.length; i++) {
                        var hasList = tiles[i].querySelector('.list-unstyled');
                        if (hasList) continue;
                        updateSavings(tiles[i]);
                    }
                }


                //==========================
                // OBSERVER (SAFE)
                //==========================
                function initObserver() {
                    var container = document.querySelector('.cart-items');
                    if (!container) return;

                    var isRunning = false;

                    var observer = new MutationObserver(function (mutations) {
                        if (isRunning) return;

                        var shouldRun = false;

                        for (var i = 0; i < mutations.length; i++) {
                            var m = mutations[i];

                            if (m.addedNodes.length > 0 || m.removedNodes.length > 0) {
                                shouldRun = true;
                                break;
                            }
                        }

                        if (!shouldRun) return;

                        isRunning = true;

                        setTimeout(function () {
                            updateSavingsAll();
                            isRunning = false;
                        }, 50);
                    });

                    observer.observe(container, {
                        childList: true,
                        subtree: true
                    });
                }


                //==========================
                // INIT
                //==========================
                function init() {
                    injectStyles();
                    updateSavingsAll();
                    initObserver();
                }

                init();

            })();

            console.log('Showing ' + TEST_ID + ' Variant');

        } else {
            console.log('Showing ' + TEST_ID + ' Control');
        }

    } catch (error) {
        console.error('Shoplift test ' + TEST_ID + ' failed:', error);
    }
}


//==========================
// SHOPLIFT READY CHECK
//==========================
function whenShopliftReady(cb, timeoutMs) {
    if (typeof timeoutMs !== 'number') {
        timeoutMs = 5000;
    }

    const start = Date.now();

    const tick = setInterval(function () {
        if (window.shoplift) {
            clearInterval(tick);
            cb();
        } else if (Date.now() - start > timeoutMs) {
            clearInterval(tick);
            console.warn('Shoplift not available after ' + timeoutMs + 'ms');
        }
    }, 50);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
        whenShopliftReady(initTestCHS_106D);
    });
} else {
    whenShopliftReady(initTestCHS_106D);
}

////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////

/*==============================================================================
TEST ID: [CHS-129C] [Sitewide] Header/Nav Sales Red EOSS
PLATFORM: Shoplift
DATE: 07/2026

GOAL:
Adds CSS to highlight Nav Sales Category in Red

KEY INSIGHT:
N/A

BEHAVIOR:
- Automatic Trigger
- Append CSS rules
==============================================================================*/

// Initialize test
async function initTestCHS_129C() {
	
	// Configuration
	const TEST_ID = 'CHS_129C';
	const HYPOTHESIS_ID = '019efaa3-6ae3-7e56-99ce-9671f6b8678c';
	let variantResult = null;
	

	try {
	// Check if visitor is in the variant group
	variantResult = await window.shoplift.isHypothesisActive(HYPOTHESIS_ID);

		if (variantResult) {
			// Create or reuse the canonical style CSS (append-safe)
			const STYLE_ID = `${TEST_ID}-CSS`;
			let style = document.getElementById(STYLE_ID);

			if (!style) {
				style = document.createElement('style');
				style.id = `${TEST_ID}-CSS`;
				document.head.appendChild(style);
			}

			// Append CSS rules (does NOT overwrite existing ones)
			// TEST - Show Variant
			
			style.appendChild(
				document.createTextNode(`
				/* ${style.id} - Nav Category Sales Red Highlight */

					li.menu-list__list-item:nth-child(7) .menu-list__link-title.caption {
						color: #D10707!important;
						}
				`)
			);
			console.log(`Showing ${TEST_ID} Variant`);
		} else {
			// Show control
			// NO CHANGES DO NOTHING
			console.log(`Showing ${TEST_ID} Control`);
		}
	} catch (error) {
		// Always fail gracefully - show control experience on error
		console.error(`Shoplift test ${TEST_ID} failed:`, error);
		}
		
}

// Guard Check - Safely Checking for Shoplift
function whenShopliftReady(cb, timeoutMs = 5000) {
    const start = Date.now();

    const tick = setInterval(function () {
        if (window.shoplift) {
            clearInterval(tick);
            cb();
        } else if (Date.now() - start > timeoutMs) {
            clearInterval(tick);
            console.warn('Shoplift not available after ' + timeoutMs + 'ms');
        }
    }, 50);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => whenShopliftReady(initTestCHS_129C));
} else {
    whenShopliftReady(initTestCHS_129C);
}

////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////

/*==============================================================================
TEST ID: [CHS-124] [PDP] Featured 5-Star Reviews [ALL]
PLATFORM: Shoplift
DATE: 2026-07

GOAL:
This test will select a 5 Star review to be featured under the Gallery Image to highlight positive customer feedback.
The selection of which 5 star review is random but has certain criteria to select which review to display as featured.

KEY INSIGHT:

BEHAVIOR:
- Only runs on PDPs that contain Reviews
- Small delay since Review section has to load on the page first
- No featured review is shown if there are no 5 star reviews to pull from
- Ingnores missing/empty reviews or has anonymous author
- Stronger bias toward reviews with longer copy
==============================================================================*/

// Initialize test
async function initTestCHS_124() {

  /* ===========================
     CONFIG
     =========================== */
  const TEST_ID = 'CHS124';
  const HYPOTHESIS_ID = '019eff95-c629-7737-a1b3-e18c2acd1f99';
  var STYLE_ID = TEST_ID + '-CSS';
  var MAX_WAIT_MS = 15000;
  var POLL_INTERVAL_MS = 300;

  /* ===========================
     HELPERS
     =========================== */

  function getText(el) {
    if (!el) return '';
    return String(el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function isValidFiveStar(item) {
    var authorEl = item.querySelector('.yotpo-reviewer-name-text');
    var author = authorEl ? authorEl.textContent.trim() : '';
    if (!author || author.toLowerCase() === 'anonymous') return false;

    var ratingEl = item.querySelector('.yotpo-review-star-rating[aria-label]');
    if (!ratingEl) return false;

    return /5 out of 5/.test(ratingEl.getAttribute('aria-label'));
  }

  function extractReview(item) {
    if (!isValidFiveStar(item)) return null;

    var titleEl = item.querySelector('.yotpo-review-title');
    var bodyEl = item.querySelector('.yotpo-read-more-text');
    if (!bodyEl) return null;

    return {
      author: item.querySelector('.yotpo-reviewer-name-text').textContent.trim(),
      title: titleEl ? getText(titleEl) : '',
      body: getText(bodyEl)
    };
  }

  function getScore(r) {
    var base = (r.title.length * 1) + (r.body.length * 2.5);
    if (base < 50) base *= 0.25;
    return Math.pow(Math.max(1, base), 2);
  }

  function pickWeighted(arr) {
    var total = 0;
    var scores = [];

    for (var i = 0; i < arr.length; i++) {
      scores[i] = getScore(arr[i]);
      total += scores[i];
    }

    var rand = Math.random() * total;
    var acc = 0;

    for (var j = 0; j < arr.length; j++) {
      acc += scores[j];
      if (rand <= acc) return arr[j];
    }

    return arr[0];
  }

  /* ===========================
     INIT (TARGETING + READINESS)
     =========================== */

  /* ✅ PDP targeting */
  if (!window.location.pathname.includes('/products/')) {
	console.log(`Not in ${TEST_ID} Test`);
    return;
  }

  var startTime = Date.now();
  var timer = setInterval(async function () {

    var items = document.querySelectorAll('li.yotpo-reviews-item');

    /* ✅ wait for Yotpo */
    if (!items.length && Date.now() - startTime < MAX_WAIT_MS) return;

    clearInterval(timer);

    /* ✅ validate usable reviews */
    var reviews = [];

    for (var i = 0; i < items.length; i++) {
      var data = extractReview(items[i]);
      if (data) reviews.push(data);
    }

    if (!reviews.length) {
		console.log(`${TEST_ID} No 5 Star Reviews`);
		return;
	}

    try {
      var variantResult = await window.shoplift.isHypothesisActive(HYPOTHESIS_ID);

      if (!variantResult) {
        console.log(`Showing ${TEST_ID} Control`);
        return;
      }
	  // TEST - Show Variant
      (function () {

        //==========================
        // ONE-RUN GUARD
        //==========================
        if (window[TEST_ID + '_INIT']) return;
        window[TEST_ID + '_INIT'] = true;

        /* ===========================
           CSS INJECTION
           =========================== */
        if (!document.getElementById(STYLE_ID)) {
          var style = document.createElement('style');
          style.id = STYLE_ID;
          style.textContent = `
            #${TEST_ID}-header {
              margin: 40px 0 21px;
              font-size: 16px;
              color: #222;
              font-family: var(--font-body);
              font-weight: 600;
              line-height: 120%;
              letter-spacing: 0.06rem;
              text-transform: uppercase;
            }

            #${TEST_ID} {
              background: #f9f7f2;
              border-radius: 8px;
              padding: 20px;
              margin-bottom: 12px;
              opacity: 0;
              transform: translateY(10px);
              transition: opacity 260ms ease, transform 260ms ease;
            }

            #${TEST_ID}.is-visible {
              opacity: 1;
              transform: translateY(0);
            }

            #${TEST_ID} .ch-hr-meta {
              display: flex;
              align-items: center;
              margin-bottom: 8px;
            }

            #${TEST_ID} .ch-hr-meta-author {
              color: #fff;
              font-weight: 600;
              border: 3px solid #222;
              background-color: #222;
              border-radius: 16px;
              padding: 1px 5px 0 4px;
              font-size: 11px;
            }

            #${TEST_ID} .ch-hr-meta-author i.fa.fa-user-circle {
              font-size: 16px !important;
              vertical-align: text-top;
              padding-right: 3px;
              margin-left: -2px;
              color: #fff;
            }

            #${TEST_ID} .ch-hr-meta span {
              padding-left: 8px;
              font-size: 17px;
            }

            #${TEST_ID} .ch-hr-meta-title {
              font-size: 16px;
              font-weight: 500;
            }

            #${TEST_ID} p {
              margin: 7px 0;
              line-height: 1.5;
              color: #444;
              font-size: 14px;
            }

            #${TEST_ID} .ch-hr-read-more {
              margin-top: 12px;
            }

            #${TEST_ID} .ch-hr-read-more a {
              font-size: 13px;
              text-decoration: underline;
              text-underline-offset: 2px;
              cursor: pointer;
            }

            @media (max-width: 749px) {
              #${TEST_ID}-header { margin: 0px 0px -20px; }
              #${TEST_ID} { margin: 0px 0px -10px; }
            }
          `;
          document.head.appendChild(style);
        }

        /* ===========================
           PLACEMENT
           =========================== */

        var isMobile = window.matchMedia('(max-width: 767px)').matches;

        var placement = isMobile
          ? document.getElementById('product-information-section')
          : document.querySelector('media-gallery');

        if (!placement) return;
		
		/* ✅ Secondary guard (DOM-level) */
        if (document.getElementById(TEST_ID)) return;

        var chosen = pickWeighted(reviews);

        /* ===========================
           BUILD
           =========================== */

        var header = document.createElement('h4');
        header.id = TEST_ID + '-header';
        header.textContent = 'What our customers are saying';

        var container = document.createElement('div');
        container.id = TEST_ID;

        container.innerHTML =
          '<div class="ch-hr-meta">' +
            '<div class="ch-hr-meta-author">' +
              '<i class="fa fa-user-circle" aria-hidden="true"></i>' +
              chosen.author +
            '</div>' +
            '<span>★★★★★</span>' +
          '</div>' +
          (chosen.title ? '<div class="ch-hr-meta-title">' + chosen.title + '</div>' : '') +
          '<p>“' + chosen.body + '”</p>' +
          '<p class="ch-hr-read-more">' +
            '<a href="#" data-scroll-to-yotpo>Read more reviews</a>' +
          '</p>';

        /* ===========================
           RENDER
           =========================== */

        placement.appendChild(header);
        placement.appendChild(container);

        var link = container.querySelector('[data-scroll-to-yotpo]');
        if (link) {
          link.addEventListener('click', function (e) {
            e.preventDefault();

            var target = document.getElementById('yotpo-app');
            if (!target) return;

            var offset = 120;
            var y = target.getBoundingClientRect().top + window.pageYOffset - offset;

            window.scrollTo({
              top: y,
              behavior: 'smooth'
            });
          });
        }

        container.offsetWidth;
        container.className += ' is-visible';
		console.log(`Showing ${TEST_ID} Variant`)
      })();

    } catch (error) {
	  // Always fail gracefully - show control experience on error	
      console.error(`Shoplift test ${TEST_ID} failed:`, error);
    }

  }, POLL_INTERVAL_MS);
}

/* Guard Check - Safely Checking for Shoplift */
function whenShopliftReady(cb, timeoutMs = 5000) {
  const start = Date.now();

  const tick = setInterval(function () {
    if (window.shoplift) {
      clearInterval(tick);
      cb();
    } else if (Date.now() - start > timeoutMs) {
      clearInterval(tick);
      console.warn('Shoplift not available after ' + timeoutMs + 'ms');
    }
  }, 50);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => whenShopliftReady(initTestCHS_124));
} else {
  whenShopliftReady(initTestCHS_124);
}

////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////				